document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('[data-elivora-reviews]').forEach((section) => {
    const track = section.querySelector('[data-elivora-review-track]');
    const prev = section.querySelector('[data-elivora-review-prev]');
    const next = section.querySelector('[data-elivora-review-next]');

    if (!track || !prev || !next) return;

    const scrollAmount = () => {
      const card = track.querySelector('.eh-review-card');
      return card ? card.getBoundingClientRect().width + 16 : track.clientWidth * 0.85;
    };

    prev.addEventListener('click', () => {
      track.scrollBy({ left: -scrollAmount(), behavior: 'smooth' });
    });

    next.addEventListener('click', () => {
      track.scrollBy({ left: scrollAmount(), behavior: 'smooth' });
    });
  });
});
